module.exports = __webpack_public_path__ + "img/pic1.2b0912fa.webp";